export default [
  {
    path: 'installment-bill',
    name: 'list-debt-installment-bill',
    component: () =>
      import(
        /* webpackChunkName: "list-debt-installment-bill" */ './list/index.vue'
      ),
    meta: {
      title: 'Công nợ trả góp hóa đơn theo ngày - Clickbuy',
    },
  },
];
